import { BRAND } from "@/lib/branding";

interface BrandNameProps {
  className?: string;
  size?: "sm" | "md" | "lg";
}

export function BrandName({ className = "", size = "md" }: BrandNameProps) {
  const sizeStyles = {
    sm: {
      uptime: "text-base",
      wing: "text-base",
      gap: "gap-1",
      container: "flex-row items-center",
    },
    md: {
      uptime: "text-2xl",
      wing: "text-2xl",
      gap: "gap-1.5",
      container: "flex-row items-center",
    },
    lg: {
      uptime: "text-4xl",
      wing: "text-4xl",
      gap: "gap-2",
      container: "flex-row items-center",
    },
  };

  const styles = sizeStyles[size];

  return (
    <div className={`flex leading-none tracking-tighter items-center ${className}`}>
      <span className={`${styles.uptime} font-black text-black uppercase`}>
        UPTIMEWING
      </span>
    </div>
  );
}
